// import Carousel from 'react-bootstrap/Carousel';
import React from "react";
import { Carousel } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Scroll.css'
function Scroll() {
  return (
    <Carousel variant="dark">
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://is5-ssl.mzstatic.com/image/thumb/nc6_OLkCV3TgiHCklTQbMg/1679x945sr.webp"
          alt="First slide"
        />
        <Carousel.Caption>
          <h1>JASON SUDEIKIS</h1>
          <h2 style={{color:"white"}}>TED LASSO</h2>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://is3-ssl.mzstatic.com/image/thumb/Gn-M-XkgARndHzKMUb_6dA/1679x945sr.webp"
          alt="Second slide"
        />
        <Carousel.Caption>
          <h2>SHRINKING</h2>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://is2-ssl.mzstatic.com/image/thumb/rV4S9xWc5p3ow4CuIZ5sTg/1679x945sr.webp"
          alt="Third slide"
        />
        <Carousel.Caption>
          <h1>JASON MOMA</h1>
          <h2>SEE</h2>
          <h1>
           THE FINAL CHAPTER
          </h1>
        </Carousel.Caption>
      </Carousel.Item>
      <Carousel.Item>
        <img
          className="d-block w-100"
          src="https://is1-ssl.mzstatic.com/image/thumb/l62wV9iq0Lhrvd1VpWTLzQ/1679x945sr.webp"
          alt="Third slide"
        />
        <Carousel.Caption>
         
          <h2>TRUTH</h2>
          <h1>
           BE TOLD
          </h1>
          <h1>NEW EPISODE FRIDAYS </h1>
        </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
  );
}


export default Scroll;